import { memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { useNavigate } from 'react-router-dom';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import { StickyDiv } from 'shell/components/shared/sticky-div';

interface ButtonsProps {
  handleOpenModal: () => void;
  isBeware?: boolean;
}

const ButtonsComponent = ({ handleOpenModal, isBeware }: ButtonsProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <StickyDiv>
      <StepButton active fullWidth>
        <StepTypography active>Anagrafe</StepTypography>
      </StepButton>
      <div className="pmi-pt-4">
        {isBeware ? (
          <div className="pmi-pb-2">
            <PmiButton color="cdmBrandThird" variant="outlined" fullWidth type="submit">
              Conferma
            </PmiButton>
          </div>
        ) : undefined}
        <div className="pmi-pb-2">
          <PmiButton color="cdmBrandThird" variant="outlined" fullWidth type="reset" id="reset">
            Pulisci
          </PmiButton>
        </div>
        <div className="pmi-pb-2">
          <PmiButton
            color="cdmBrand"
            variant="contained"
            fullWidth
            onClick={() => {
              if (isBeware) {
                handleOpenModal();
                return;
              }
              navigate('/mutazioni');
            }}
          >
            Esci
          </PmiButton>
        </div>
      </div>
    </StickyDiv>
  );
};

ButtonsComponent.displayName = 'Registration beware page component';

const Buttons = memo(ButtonsComponent);

export default Buttons;
